// §4.4 — auth route partial. Composer auto-collects this into routes.generated.ts.
// /login, /post-login, /refresh are all public (no RequireAuth wrapper here).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import LoginPage from "./pages/LoginPage";

// The root session guard sends unauthenticated visitors here. Keeping this
// critical route eager avoids a second network waterfall after session lookup.
const PostLoginPage = lazyWithRetry(() => import("./pages/PostLoginPage"));
const RefreshPage = lazyWithRetry(() => import("./pages/RefreshPage"));

export const ROUTES = {
  LOGIN: "/login",
  POST_LOGIN: "/post-login",
  REFRESH: "/refresh",
} as const;

const routes: RouteObject[] = [
  { path: ROUTES.LOGIN, Component: LoginPage },
  { path: ROUTES.POST_LOGIN, Component: PostLoginPage },
  { path: ROUTES.REFRESH, Component: RefreshPage },
];

export default routes;
